<script>
	import { onMount } from 'svelte';
	import { userid } from './utils';
	import LED from './components/LED.svelte';
	import { NotificationDisplay } from '@shopboxai/sb-portal-components';
	export let user = {};
	export let production = false;
	let mounted = false;

	onMount(() => {
		$userid = user;
		// $userid =
		// 	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Njk4ODk0OTIsInN1YiI6ImYwNTliY2UxLTg4NmQtNDFmYy05YTEyLWJkY2UzZmUzNDVjNyJ9.dpALy2yhL40gBW7Lr3f-LHyUpnddDXOl6-UF6NHmFv4';

		mounted = true;
	});
</script>

{#if mounted}
	<main>
		<NotificationDisplay />
		<div class="app-container">
			<LED />
		</div>
	</main>
{/if}

<style>
	/* Standart styles accross portal apps */

	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
		margin: 0;
		padding: 0;
	}

	main {
		width: 100%;
		position: relative;
	}
	:global(:is(h1, h2)) {
		font-family: 'Chivo', sans-serif;
	}
	:global(:is(h1)) {
		font-weight: 900;
	}
	:global(header) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em 0;
		border-bottom: 1px solid #dadada;
		margin-bottom: 1em;
	}
</style>
